// Icons
import FlagBN from "assets/icons/glory/flag-bn.svg?react";
import FlagEN from "assets/icons/glory/flag-en.svg?react";
import FlagRU from "assets/icons/glory/flag-ru.svg?react";
import FlagKZ from "assets/icons/glory/flag_kz.svg?react";
import FlagTR from "assets/icons/glory/flag-tr.svg?react";
import FlagUZ from "assets/icons/glory/flag-uz.svg?react";
import FlagMM from "assets/icons/glory/flag-mm.svg?react";
import FlagLK from "assets/icons/glory/flag-lk.svg?react";
import FlagFR from "assets/icons/glory/flag-fr.svg?react";
import FlagAZ from "assets/icons/glory/flag-az.svg?react";
import FlagNE from "assets/icons/glory/flag-ne.svg?react";
import FlagVN from "assets/icons/glory/flag-vn.svg?react";
import FlagKO from "assets/icons/glory/flag-ko.svg?react";
import FlagMS from "assets/icons/glory/flag-ms.svg?react";

export type LanguageType = {
  id: number;
  img?: string;
  name: string;
  isoCode: string;
};

export type LanguageListType = {
  img: string;
  name: string;
};

export const LANGUAGES = {
  BN: {
    img: <FlagBN />,
    orig: "বাংলা",
    eng: "Bengali",
  },
  EN: {
    img: <FlagEN />,
    orig: "English",
    eng: "English",
  },
  RU: {
    img: <FlagRU />,
    orig: "Русский",
    eng: "Russian",
  },
  KZ: {
    img: <FlagKZ />,
    orig: "Қазақша",
    eng: "Kazakh",
  },
  TR: {
    img: <FlagTR />,
    orig: "Türkçe",
    eng: "Turkish",
  },
  UZ: {
    img: <FlagUZ />,
    orig: "O'zbek",
    eng: "Uzbek",
  },
  MM: {
    img: <FlagMM />,
    orig: "മല്യയാമി",
    eng: "Burmese",
  },
  SI: {
    img: <FlagLK />,
    orig: "සිංහල",
    name: "Sinhala",
  },
  FR: {
    img: <FlagFR />,
    orig: "Français",
    name: "French",
  },
  AZ: {
    img: <FlagAZ />,
    orig: "Azərbaycan",
    name: "Azerbaijani",
  },
  NE: {
    img: <FlagNE />,
    orig: "नेपाली",
    name: "Nepali",
  },
  VI: {
    img: <FlagVN />,
    orig: "Tiếng Việt",
    name: "Vietnamese",
  },
  KO: {
    img: <FlagKO />,
    orig: "한국인",
    name: "Korean",
  },
  MS: {
    img: <FlagMS />,
    orig: "Bahasa Melayu",
    name: "Malay",
  },
};
